import React from 'react';
import { t } from 'ttag';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { Flex } from '~/ui/flex/Flex';
import { ThumbsPages, useThumbsStore } from '../Store';
import { IssueForm } from './Form';

export const FeedbackNegative = () => {
  const { page, setPage } = useThumbsStore();

  if (page !== ThumbsPages.FeedbackNegative) return null;

  return (
    <>
      <CloseButton onClick={() => setPage(ThumbsPages.Root)} />
      <Flex variant="list" gap="md">
        <IssueForm
          topic={'thumbs_down'}
          label={t`Oh no! Tell us what could improve?`}
        />
      </Flex>
    </>
  );
};
